import {Component, OnInit} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-monitoring-info',
  templateUrl: './monitoring-info.component.html',
  styleUrls: ['./monitoring-info.component.scss']
})
export class MonitoringInfoComponent implements OnInit {
  items = [
    'MinimumToOpenAccount',
    'IntradayTrading',
    'MediumLongTermInvestments',
    'AccountLeverage',
    'InsuranceOnAccount',
    'SupervisoryBodies',
    // 'IdentificationForAccountHolder',
  ];

  itemsMobile = [
    'InsuranceOnAccount',
    'IntradayTrading',
    'AccountLeverage'
  ];

  constructor() {
  }

  get isMobile(): boolean {
    return window.innerWidth < 1199;
  }

  ngOnInit() {
  }

}
